<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  openid: "", //家长openid:123456--老师的ov0ks6HtbE_v9AR3yLNknzJQIwPw
  code: "",
  created() {
    console.log("我是App得onload方法");
    this.onload();
  },
  methods: {
    onload() {
      //本地测试用信息
      //pinfo:#姓名#身份#工号学号#电话#学校Id#部门
      //老师
      // let openId="ov0ks6CGLrwZlIbUgSUz6Br8Od5E"
      // let pinfo="刘老师#老师#888#18622335644##二中"

      //家长
      // let openId="ov0ks6CGLrwZlIbUgSUz6Br8Od5E"
      // let pinfo="aa#家长##123456"

      //学生
      // let openId="ov0ks6AJYZSWXY-rMj82xhsXo9Ro"
      // let pinfo="杨文文#学生#JH0006#"

      // window.localStorage.setItem("openid",openId );
      // let strArray = pinfo.split("#");
      // this.user = [
      //   {
      //     username: strArray[0],
      //     shenfen: strArray[1],
      //     number: strArray[2],
      //     phone: strArray[3],
      //     xiaoqu: strArray[4],
      //     dep: strArray[5],
      //     openid: window.localStorage.getItem("openid"),
      //   },
      // ];
      // window.localStorage.setItem("User", JSON.stringify(this.user));

      //获取本地保存得openid
      this.openid = window.localStorage.getItem("openid");

      // this.$router.push({
      //       path: "LoginType",
      //       query: {
      //         code: this.code,
      //         openid: this.openid,
      //       },
      //     });
      //     return;
      //判断openid是否存在，如果存在就直接跳转登陆后得首页。否则，跳转登陆页面。
      if (
        this.openid == " " ||
        this.openid == "undefined" ||
        this.openid == "null" ||
        this.openid == null ||
        this.openid == ""
      ) {
        let name = "code";
        var str = window.location.search;
        if (str.indexOf("code") != -1) {
          var pos_start = str.indexOf(name) + name.length + 1;
          var pos_end = str.indexOf("&", pos_start);
          if (pos_end == -1) {
            this.code = str.substring(pos_start);
          } else {
            this.code = str.substring(pos_start, pos_end);
          }
        }
        this.Get_Openid(this.code);
      } else {
        var json = window.localStorage.getItem("User");
        var jsonObj = JSON.parse(json);
        console.log(jsonObj);
        if (
          JSON.stringify(jsonObj) == "{}" ||
          JSON.stringify(jsonObj) == "null" ||
          JSON.stringify(jsonObj) == null
        ) {
          this.$router.push({
            path: "LoginType",
            query: {
              code: this.code,
              openid: this.openid,
            },
          });
        } else {
          // window.localStorage.removeItem("User");
          // this.Get_Openid(this.code);
          this.$router.push("Index");
        }
      }
    },
    Get_Openid(logincode) {
      logincode;
      var params_json = {
        code: logincode,
      };
      this.$http.post("/web/getOpenId", params_json).then(function (res) {
        let obj = res.data;
        if (
          obj.openId == " " ||
          obj.openId == "undefined" ||
          obj.openId == "null" ||
          obj.openId == null ||
          obj.openId == ""
        ) {
          this.$router.push({
            path: "err",
            query: {
              code: this.code,
            },
          });
        } else {
          window.localStorage.setItem("openid", obj.openId); //obj.openId
          this.openid = obj.openId; //obj.openId;
          if (obj.msg == "" || obj.msg == null) {
            this.$router.push({
              path: "LoginType",
              query: {
                code: this.code,
                openid: this.openid,
              },
            });
          } else {
            var strArray = obj.msg.split("#");
            console.log("返回得用户信息:" + strArray);
            this.user = [
              {
                username: strArray[0],
                number: strArray[2],
                shenfen: strArray[1],
                phone: strArray[3],
                xiaoqu: strArray[4],
                dep: strArray[5],
                openid: this.openid,
              },
            ];
            window.localStorage.setItem("User", JSON.stringify(this.user));
            this.$router.push("Index");
          }
        }
      });
    },
  },
};
</script>

<style>
body {
  font-family: Arial, Helvetica, sans-serif;
}
</style>